module.exports = __webpack_public_path__ + "img/enterprise-main08.70455ca8.png";